var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group',{attrs:{"config":Object.assign({}, _vm.config, {draggable: _vm.draggable})}},[_c('Label',{ref:("label-" + _vm.name),attrs:{"config":_vm.labelConfig,"scale":_vm.labelScale,"background-color":_vm.labelBackgroundColor}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }